"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SYSTEM_THEME_ID = exports.LOCAL_STORAGE_KEY = exports.LIGHT_THEME_ID = exports.DARK_THEME_ID = void 0;
var LIGHT_THEME_ID = exports.LIGHT_THEME_ID = 'light';
var DARK_THEME_ID = exports.DARK_THEME_ID = 'dark';
var SYSTEM_THEME_ID = exports.SYSTEM_THEME_ID = 'system';
var LOCAL_STORAGE_KEY = exports.LOCAL_STORAGE_KEY = 'theme';